export default "__VITE_ASSET__3BnY45bS__"